import builder from '../builder';
import PaginateFilterMailAlternate from '../../streamline-icons/bold/paginate-filter-mail-alternate.svg';

export default builder(
  'IconPaginateFilterMailAlternateBold',
  PaginateFilterMailAlternate,
);
